import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  public active_link;
  constructor(private router: Router) { }

  ngOnInit(): void {
    this.toggleClassMenu();
  }

  toggleClassMenu() {
    if (this.router.url === '/a-propos') {
      
      this.active_link = "/a-propos"
      
    }
    if (this.router.url === '/formations') {
      
      this.active_link = "/formations"
      
    }
    if (this.router.url === '/contact') {
      
      this.active_link = "/contact"
      
    }
    if (this.router.url === '/key-figures') {
      
      this.active_link = "/key-figures"
      
    }
  }

}
